import Vue from 'vue'
import Router from 'vue-router'
import home from '@/pages/home'
import imageList from '@/pages/imageList'
import wzList from '@/pages/wzList'
import journalList from '@/pages/journalList'
import journalList2 from '@/pages/journalList2'
import journal from '@/pages/journal'
import aboutUs from '@/pages/aboutUs'
import munePage from '@/pages/munePage'
import works from '@/pages/works'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      // component: xyVip,
      component: resolve => require(['../views/index'], resolve),
      // meta: { title: '首页' }
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    },
    {
      path: '/rz',
      name: 'rz',
      // component: xyVip,
      component: resolve => require(['../views/rizhi'], resolve),

    }, {
      path: '/zp',
      name: 'zp',
      // component: xyVip,
      component: resolve => require(['../views/zp'], resolve),

    }, {
      path: '/ab',
      name: 'ab',
      // component: xyVip,
      component: resolve => require(['../views/ab'], resolve),

    }, {
      path: '/wks',
      name: 'wks',
      // component: xyVip,
      component: resolve => require(['../views/works'], resolve),

    },
    {
      path: '/home',
      name: 'home',
      component: home,
      // meta: { title: '首页' }
    },
    {
      path: '/imageList',
      name: 'imageList',
      component: imageList,
      // meta: { title: '作品列表' }
    },
    // {
    //   path: '/wzList',
    //   name: 'wzList',
    //   component: wzList,
    //   meta: { title: '作品列表_文字检索(作废)' }
    // },
    {
      path: '/journalList',
      name: 'journalList',
      component: journalList,
      // meta: { title: '日志列表_图片检索' }
    },
    // {
    //   path: '/journalList2',
    //   name: 'journalList2',
    //   component: journalList2,
    //   meta: { title: '日志列表_文字检索'}
    // },
    {
      path: '/journal',
      name: 'journal',
      component: journal,
      // meta: { title: '日志内容' }
    },
    {
      path: '/munePage',
      name: 'munePage',
      component: munePage,
      // meta: { title: '联系我们' }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs,
      // meta: { title: '关于合恣' }
    }, {
      path: '/works',
      name: 'works',
      component: works,
      // meta: { title: '作品内容' }
    },


  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js